import React from "react";
import TagError from '../img/icons/tag-error.svg';
import TagValid from '../img/icons/tag-valid.svg';

const getClasses = (isErrored, showValidation) => {
    let classes = 'required-tag ';
    if (isErrored && showValidation) classes += 'has-error';
    else if (showValidation) classes += 'valid';
    return classes;
};

export const RequiredTag = ({ isErrored, showValidation }) => (
    <div className={getClasses(isErrored, showValidation)}>
        <div className={'required-tag-container'} data-testid={'required-tag'}>
            {
                showValidation &&
                <img alt="null" src={showValidation && isErrored ? TagError : TagValid} data-testid={`required-tag-${isErrored ? 'invalid' : 'valid'}`}/>
            }
            <p>Required</p>
        </div>
    </div>
);